import React from "react";
import { ShieldAlert, MessageCircle, Gift, ListChecks, Zap, CheckCircle2 } from "lucide-react";

export const ActionPlanBody = ({ plan }) => {
  const offer = plan.offerta_consigliata;
  return (
    <div className="space-y-3" data-testid="action-plan">
      <div className="rounded-xl border border-primary/30 bg-primary/5 p-4">
        <div className="label-caps text-primary">Leva principale</div>
        <p className="mt-1 text-sm font-medium">{plan.leva_principale}</p>
        {plan.hook_apertura && <p className="mt-2 text-sm italic text-foreground/80">“{plan.hook_apertura}”</p>}
      </div>

      <Section icon={Zap} title="Perché scegliere 20/80LAB">
        <ul className="space-y-1.5 text-sm">{(plan.perche_noi || []).map((x) => <li key={x} className="flex gap-2"><CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-[#22C55E]" />{x}</li>)}</ul>
      </Section>

      <Section icon={MessageCircle} title="Argomenti di vendita">
        <div className="space-y-2">{(plan.argomenti || []).map((a) => (
          <div key={a.titolo} className="rounded-lg border border-border p-3"><div className="text-sm font-semibold">{a.titolo}</div><p className="mt-0.5 text-sm text-foreground/85">{a.testo}</p></div>
        ))}</div>
      </Section>

      <Section icon={ShieldAlert} title="Obiezioni previste">
        <div className="space-y-2">{(plan.obiezioni || []).map((o) => (
          <div key={o.obiezione} className="rounded-lg border border-border p-3">
            <div className="text-sm text-[#EAB308]">“{o.obiezione}”</div>
            <p className="mt-1 text-sm text-foreground/85">→ {o.risposta}</p>
          </div>
        ))}</div>
      </Section>

      {offer && (
        <Section icon={Gift} title="Offerta consigliata">
          <div className="grid grid-cols-2 gap-2 text-sm">
            <Kv k="Servizio" v={offer.servizio} highlight />
            <Kv k="Prezzo" v={offer.prezzo_indicativo} />
            <Kv k="Durata" v={offer.durata} />
            <Kv k="Risultato promesso" v={offer.risultato_promesso} />
          </div>
          <p className="mt-2 text-sm text-foreground/85">{offer.pacchetto}</p>
        </Section>
      )}

      <Section icon={ListChecks} title="Sequenza consigliata">
        <div className="space-y-1.5">{(plan.sequenza || []).map((s) => (
          <div key={`${s.giorno}-${s.canale}`} className="flex items-center gap-3 text-sm">
            <span className="w-10 shrink-0 rounded bg-secondary px-1.5 py-0.5 text-center text-xs font-semibold">D{s.giorno}</span>
            <span className="w-24 shrink-0 text-xs text-primary">{s.canale}</span>
            <span className="text-foreground/85">{s.obiettivo}</span>
          </div>
        ))}</div>
      </Section>

      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
        <div className="rounded-xl border border-[#22C55E]/30 bg-[#22C55E]/5 p-3"><div className="label-caps text-[#22C55E]">Primo passo oggi</div><p className="mt-1 text-sm">{plan.primo_passo}</p></div>
        <div className="rounded-xl border border-[#EF4444]/30 bg-[#EF4444]/5 p-3"><div className="label-caps text-[#EF4444]">Rischio principale</div><p className="mt-1 text-sm">{plan.rischio_principale}</p></div>
      </div>
      <div className="text-right text-[0.65rem] text-muted-foreground">Generato {(plan.generated_at || "").slice(0, 16).replace("T", " ")}</div>
    </div>
  );
};

function Section({ icon: Icon, title, children }) {
  return (
    <div className="rounded-xl border border-border p-4">
      <div className="mb-2 flex items-center gap-2 label-caps text-muted-foreground"><Icon className="h-3.5 w-3.5" /> {title}</div>
      {children}
    </div>
  );
}

function Kv({ k, v, highlight }) {
  return (
    <div className={`rounded-lg border p-2 ${highlight ? "border-primary/40 bg-primary/5" : "border-border"}`}>
      <div className="text-[0.6rem] uppercase tracking-wide text-muted-foreground">{k}</div>
      <div className={`text-sm font-medium ${highlight ? "text-primary" : ""}`}>{v || "—"}</div>
    </div>
  );
}
